import React from "react";
import { Link } from "react-router-dom";
import { useKT } from "../i18n/kt";
import { kp } from "../karkhanaPaths";

/** Attendance has two kinds of work: hours (in / out) and job work (per job, colour or saree). */
const AttendanceTabs = ({ active, hours, jobs }: { active: "hours" | "jobs"; hours?: number | string; jobs?: number | string }) => {
  const { t } = useKT();
  return (
    <div className="kat-tabs" role="tablist" aria-label={t("Attendance")}>
      <Link to={kp.attendance()} role="tab" aria-selected={active === "hours"} className={active === "hours" ? "is-on" : ""}>
        {t("Hours")}
        {hours !== undefined ? ` · ${hours}` : ""}
      </Link>
      <Link to={kp.jobWork()} role="tab" aria-selected={active === "jobs"} className={active === "jobs" ? "is-on" : ""}>
        {t("Job work")}
        {jobs !== undefined ? ` · ${jobs}` : ""}
      </Link>
    </div>
  );
};

export default AttendanceTabs;
